import type { Strapi4RequestParams } from '@nuxtjs/strapi'
import type { FetchOptions } from 'ofetch'
import {
  JOBS_REST_SEGMENT,
  type JobDetailResponse,
  type JobListQueryParams,
  type JobListResponse
} from '@profilpublic/api-contract/job'

const RESOURCE = 'jobs' as const

/**
 * Strapi `jobs` collection helpers typed against `@profilpublic/api-contract/job`.
 * Uses `useStrapi4()` for `find` / `findOne` and `useStrapiClient()` for REST paths under `/jobs`.
 */
export function useJobsApi() {
  const { find, findOne } = useStrapi4()
  const client = useStrapiClient()

  function toStrapiParams(params?: JobListQueryParams): Strapi4RequestParams | undefined {
    return params as unknown as Strapi4RequestParams | undefined
  }

  function findJobs(params?: JobListQueryParams, fetchOptions?: FetchOptions) {
    return find<JobListResponse>(RESOURCE, toStrapiParams(params), fetchOptions)
  }

  function findOneJob(idOrSlug: string | number, params?: Strapi4RequestParams, fetchOptions?: FetchOptions) {
    return findOne<JobDetailResponse>(RESOURCE, idOrSlug, params, fetchOptions)
  }

  function recordJobView(jobId: string | number, body: { url: string }, options?: FetchOptions) {
    return client(`${JOBS_REST_SEGMENT}/${jobId}/view`, {
      method: 'POST',
      body,
      ...options
    })
  }

  return {
    collection: RESOURCE,
    basePath: JOBS_REST_SEGMENT,
    findJobs,
    findOneJob,
    recordJobView,
    client
  }
}
